import { useEffect, useState } from "react";
import axios from "axios";
import Reveal from "@/components/Reveal";
import { YoutubeLogo, FacebookLogo, InstagramLogo, TiktokLogo, ArrowUpRight } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const YT_EMBED = "https://www.youtube.com/embed/videoseries?list=UUrDHXRc3e45b5icQ6QuKjcQ";
const YT_CHANNEL = "https://www.youtube.com/@vientodegracia9235";

const NETWORKS = [
  { key: "youtube", n: "01", name: "YouTube", note: "Predicaciones completas", id: "social-youtube" },
  { key: "instagram", n: "02", name: "Instagram", note: "Vida de la comunidad", id: "social-instagram" },
  { key: "facebook", n: "03", name: "Facebook", note: "Transmisiones en vivo", id: "social-facebook" },
  { key: "tiktok", n: "04", name: "TikTok", note: "Mensajes cortos", id: "social-tiktok" },
];

const Mensajes = () => {
  const [socials, setSocials] = useState({ youtube: YT_CHANNEL, instagram: "", facebook: "", tiktok: "" });

  useEffect(() => {
    axios
      .get(`${API}/settings`)
      .then(({ data }) => setSocials((s) => ({ ...s, ...data.socials })))
      .catch(() => {});
  }, []);

  return (
  <section id="mensajes" className="border-t border-white/10 bg-ink py-28 lg:py-36" data-testid="mensajes-section">
    <div className="mx-auto max-w-[1600px] px-6 lg:px-12">
      <div className="mb-16 grid gap-8 lg:grid-cols-2">
        <Reveal>
          <p className="mb-8 flex items-center gap-4 text-[10px] font-light uppercase tracking-[0.5em] text-fire" data-testid="mensajes-eyebrow">
            <span className="inline-block h-px w-16 bg-fire" /> Predicaciones
          </p>
          <h2 className="font-serif text-5xl leading-[0.95] tracking-tight text-paper sm:text-7xl" data-testid="mensajes-title">
            Mensajes que <em className="italic text-gold">renuevan</em>
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="flex items-end">
          <p className="max-w-md text-sm font-light leading-relaxed tracking-wide text-smoke">
            Revive las predicaciones y momentos de nuestra congregación desde donde estés.
            Suscríbete y síguenos en nuestras redes.
          </p>
        </Reveal>
      </div>

      <div className="grid gap-14 lg:grid-cols-12">
        <Reveal className="lg:col-span-7">
          <div className="group relative border border-white/10" data-testid="youtube-embed-card">
            <span className="outline-text pointer-events-none absolute -top-10 left-4 z-10 select-none font-serif text-[6rem] leading-none">YT</span>
            <iframe
              src={YT_EMBED}
              title="Predicaciones Viento de Gracia"
              className="aspect-video w-full grayscale transition-[filter] duration-700 group-hover:grayscale-0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              loading="lazy"
              data-testid="youtube-embed-iframe"
            />
            <div className="flex items-center justify-between border-t border-white/10 px-6 py-4">
              <span className="text-[10px] font-light uppercase tracking-[0.3em] text-smoke">Canal completo de predicaciones</span>
              <a href={YT_CHANNEL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-[10px] font-medium uppercase tracking-[0.3em] text-paper/70 transition-colors hover:text-fire" data-testid="mensajes-canal-link">
                Abrir en YouTube <ArrowUpRight size={13} weight="regular" />
              </a>
            </div>
          </div>
        </Reveal>

        <div className="lg:col-span-5">
          {NETWORKS.map((s, i) => {
            const url = socials[s.key];
            const inner = (
              <>
                <div className="flex items-baseline gap-6">
                  <span className="text-[10px] font-light tracking-[0.3em] text-smoke">{s.n}</span>
                  <div>
                    <p className={`font-serif text-3xl transition-colors duration-300 lg:text-4xl ${url ? "text-paper group-hover:text-fire" : "text-paper/35"}`}>{s.name}</p>
                    <p className="mt-1 text-[10px] font-light uppercase tracking-[0.25em] text-smoke">
                      {url ? s.note : "Próximamente"}
                    </p>
                  </div>
                </div>
                {url ? (
                  <ArrowUpRight size={22} weight="light" className="shrink-0 text-smoke transition-all duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-fire" />
                ) : (
                  <span className="shrink-0 border border-white/10 px-3 py-1 text-[9px] font-light uppercase tracking-[0.2em] text-smoke/60">Pronto</span>
                )}
              </>
            );
            const cls = `group flex items-center justify-between gap-6 border-t border-white/10 py-7 transition-colors duration-300 last:border-b lg:px-4 ${url ? "hover:bg-surface" : "opacity-70"}`;
            return (
              <Reveal key={s.key} delay={i * 0.08}>
                {url ? (
                  <a href={url} target="_blank" rel="noopener noreferrer" data-testid={s.id} className={cls}>
                    {inner}
                  </a>
                ) : (
                  <div data-testid={s.id} className={cls}>
                    {inner}
                  </div>
                )}
              </Reveal>
            );
          })}
        </div>
      </div>
    </div>
  </section>
  );
};

export default Mensajes;
